import debug from 'debug'

// Centralised `debug` factory. Every namespace is prefixed with `aha:` so the
// whole app's debug output can be toggled at once from the browser console with:
//   localStorage.debug = 'aha:*'        // all aha namespaces
//   localStorage.debug = 'aha:ppt:*'    // just the PowerPoint add-in
// then reload. Logging is silent unless a matching namespace is enabled, so
// these calls are safe to leave in production code.
const ROOT_NAMESPACE = 'aha'

// On local dev, enable all `aha:*` namespaces by default so logs show without
// any manual setup. Other libs (e.g. the OpenTok SDK) also write their own
// namespaces into `localStorage.debug`, so we APPEND `aha:*` to whatever is
// already there instead of overwriting — preserving their config and ours.
// Other envs stay silent unless opted in.
if (process.env.VUE_APP_ENVAPP === 'local') {
  try {
    const current = localStorage.getItem('debug') || ''
    const namespaces = current.split(',').map((n) => n.trim()).filter(Boolean)
    if (!namespaces.includes(`${ROOT_NAMESPACE}:*`)) {
      namespaces.push(`${ROOT_NAMESPACE}:*`)
      debug.enable(namespaces.join(','))
    }
  } catch (e) {
    // localStorage may be unavailable (e.g. sandboxed iframe) — ignore.
  }
}

const createDebug = (namespace) => debug(`${ROOT_NAMESPACE}:${namespace}`)

export default createDebug
export { createDebug }
